import axios from '../../api/instance';

const namespace = 'plan_installation/';

export const SET_SCHEDULING_INSTALLATION = namespace + 'SET_SCHEDULING_INSTALLATION';

export const SUBMIT_ORDER = namespace + 'submit';
export const GET_SCHEDULING_INSTALLATION = namespace + 'GET_SCHEDULING_INSTALLATION';


export default {
    state: {
        amount: null,
        schedulingInstallation: false,
    },
    mutations: {
        [SET_SCHEDULING_INSTALLATION]: (state, scheduling) => state.schedulingInstallation = scheduling,
    },
    actions: {
        async [SUBMIT_ORDER](_,payload) {
            return await axios.post('planners/api/planners/installation_contact_moment_selection', payload);
        },
    },
    getters: {
        [GET_SCHEDULING_INSTALLATION]: (state) => state.schedulingInstallation,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/plan_installation.js